import { Component, input, output } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { ConfirmedFeedbackComponent } from 'src/app/components/confirmed-feedback/confirmed-feedback.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { IBookingRating } from 'src/app/interfaces/interface';

@Component({
  selector: 'app-feedback-view',
  imports: [
    ReactiveFormsModule,
    ConfirmedFeedbackComponent,
    MatProgressSpinnerModule,
  ],
  templateUrl: './feedback-view.component.html',
  styleUrl: './feedback-view.component.scss',
})
export class FeedbackViewComponent {
  loading = input(false);

  feedbackSent = input(false);

  submitFeedback = output<IBookingRating>();

  stars = [1, 2, 3, 4, 5];

  formFeedback = new FormGroup({
    bookingRating: new FormControl(0, { nonNullable: true }),
    teamRating: new FormControl(0, { nonNullable: true }),
    comment: new FormControl('', { nonNullable: true }),
  });

  setBookingRating(value: number) {
    const current = this.formFeedback.controls.bookingRating.value;
    this.formFeedback.controls.bookingRating.setValue(
      current === value ? value - 1 : value
    );
  }

  setTeamRating(value: number) {
    const current = this.formFeedback.controls.teamRating.value;
    this.formFeedback.controls.teamRating.setValue(
      current === value ? value - 1 : value
    );
  }

  submit() {
    if (this.formFeedback.valid) {
      this.submitFeedback.emit(this.formFeedback.getRawValue());
    }
  }
}
